<template>
  <div>
    <div style="float: left; width: 80px">aaa</div>
    <div id="tool-map"></div>
  </div>
</template>
<script>
import { mixins } from './index-mixin'
export default {
  mixins: [mixins],
  data() {
    return {}
  },
}
</script>
<style scoped>
#tool-map {
  height: 1440px;
}
</style>


// WEBPACK FOOTER //
// src/components/map-tools/index.vue